declare namespace $ {

	type $mol_switch__options_shm_hitalama_speech_picker_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech_picker['speakers'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_switch__value_shm_hitalama_speech_picker_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech_picker['speaker'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_labeler__title_shm_hitalama_speech_picker_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_speech_picker_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech_picker['Speaker'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_switch__options_shm_hitalama_speech_picker_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech_picker['microphones'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_switch__value_shm_hitalama_speech_picker_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech_picker['mic'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_labeler__title_shm_hitalama_speech_picker_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_speech_picker_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech_picker['Mic'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	export class $shm_hitalama_speech_picker extends $mol_pick {
		Trigger_icon( ): $mol_icon_dots_vertical
		speakers( ): Record<string, any>
		speaker( next?: string ): string
		Speaker( ): $mol_switch
		Speaker_label( ): $mol_labeler
		microphones( ): Record<string, any>
		mic( next?: string ): string
		Mic( ): $mol_switch
		Mic_label( ): $mol_labeler
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=picker.view.tree.d.ts.map